export const calculateLost = (item: Record<string, any>) =>
  Number(item?.beg || 0) +
  Number(item?.del || 0) -
  (Number(item?.ret || 0) + Number(item.end || 0)) -
  Number(item.unu || 0);
